import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { gsap } from "../../gsap/gsap.min.js"; 

const Menu = ({ isOpen, onMenuClose }) => {
	const menuRef = useRef(null);
	const itemsRef = useRef([]);
	const location = useLocation();
	const navigate = useNavigate();
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	useEffect(() => {
		setIsMenuOpen(isOpen);
	}, [isOpen]);

	useEffect(() => {
		if (isMenuOpen) {
			gsap.fromTo(menuRef.current, { opacity: 0 }, { opacity: 1, duration: 0.5 });
			itemsRef.current.forEach((item, i) => {
				gsap.fromTo(item, { opacity: 0, y: 50 }, { opacity: 1, y: 0, duration: 0.5, delay: i * 0.1 });
			});
		} else {
			gsap.to(menuRef.current, { opacity: 0, duration: 0.5 });
		}
	}, [isMenuOpen]);

	useEffect(() => {
		if (location.pathname == '/' || location.pathname.match(/^home/)) {
			if (isMenuOpen) {
				onMenuClose();
			}
		}
	}, [location]);

	const handleScrollToSection = (sectionId) => {
		if (location.pathname == '/' || location.pathname.match(/^home/)) {
			setTimeout(() => {
				scrollToSection(sectionId);
				openAccordions(sectionId);
				onMenuClose();   
			}, 300);  // Delay per assicurarsi che l'elemento sia disponibile 
		} else {
			navigate('/');
			onMenuClose();  
			setTimeout(() => {
				scrollToSection(sectionId);
				openAccordions(sectionId);
			}, 800);  // Delay per aspettare il caricamento della Home
		}
	};


	const openAccordions = (sectionId) => {
		if (sectionId === 'about-us-section') {
			setTimeout(() => {
				const aboutAccordionButton = document.querySelector('#open-about-accordion');
				if (aboutAccordionButton) {
					aboutAccordionButton.click();
				}
			}, 1000); // Delay per aspettare che la sezione sia caricata
		}

		if (sectionId === 'expertise-section-contact') {
			setTimeout(() => {
				const aboutAccordionButton = document.querySelector('#open-expertise-accordion');
				if (aboutAccordionButton) {
					aboutAccordionButton.click();
				}
			}, 1000); // Delay per aspettare che la sezione sia caricata
		}
	};


	const scrollToSection = (sectionId) => {
		const section = document.getElementById(sectionId);
		if (section) {
			setTimeout(() => {
				gsap.to(window, {
					duration: 1,
					scrollTo: {
						y: section.offsetTop - 100
					}
				});
			}, 500)
		}
	};

	const homeScroll = () => {
		if (location.pathname == '/' || location.pathname.match(/^home/)) {
			gsap.to(window, { duration: 1, scrollTo: 0 }); 
		} else {
			navigate('/');
			setTimeout(() => {
				gsap.to(window, { duration: 1, scrollTo: 0 }); 
			}, 1000);
		}
	};

	//const handleContactClick = () => {
	//	handleScrollToSection('expertise-section');
	//	setTimeout(() => {
	//		const expertiseComponent = document.getElementById('expertise-accordion');
	//		if (expertiseComponent) {
	//			gsap.to(expertiseComponent, { height: 'auto', duration: 0.5, ease: 'power2.inOut' });
	//			onMenuClose(); 
	//		}
	//	}, 1000);
	//};

	return (
		<div ref={menuRef} className={`menu ${isMenuOpen ? 'open' : ''}`}>
			<div className="container">
				<div className="row justify-content-center">
					<nav className="col-12 col-md-8 col-lg-6 mx-auto">
						<ul className="hover-opacity-others-li">
							<li ref={el => itemsRef.current[0] = el}>
								<Link to="/" onClick={() => homeScroll()}>Home</Link>
							</li>
							<li ref={el => itemsRef.current[1] = el}>
								<button onClick={() => handleScrollToSection('about-us-section')}>About</button>
							</li>
							<li ref={el => itemsRef.current[2] = el}>
								<button onClick={() => handleScrollToSection('works-section')}>Projects</button>
							</li>
							<li ref={el => itemsRef.current[3] = el}>
								<button onClick={() => handleScrollToSection('expertise-section')}>Expertise</button>
							</li>
							<li ref={el => itemsRef.current[4] = el}>
								<button onClick={() => handleScrollToSection('expertise-section-contact')}>Contact</button>
							</li>
						</ul>
					</nav>
				</div>
				<div className="row more-info justify-content-center mt-5">
					<div className="col-12 col-md-8 col-lg-6 mx-auto d-flex flex-column flex-md-row justify-content-start align-items-md-end">
						<ul className="hover-opacity-others-li">
							{/*<li ref={el => itemsRef.current[5] = el}>*/}
							{/*	<a href="" target="_blank">X</a>*/}
							{/*</li>*/}
							{/*<li ref={el => itemsRef.current[6] = el}>*/}
							{/*	<a href="" target="_blank">INSTAGRAM</a>*/}
							{/*</li>*/}
							<li ref={el => itemsRef.current[5] = el}>
								<a href="https://www.linkedin.com/company/epocaadvisoring/" target="_blank">LINKEDIN</a>
							</li><li ref={el => itemsRef.current[6] = el}>
								<a href="mailto:info@epocagroup.it" target="_blank">MAIL US</a>
							</li>
						</ul>
						{/*<ul className="hover-opacity-others-li ms-md-5">*/}
						{/*	<li ref={el => itemsRef.current[9] = el}>*/}
						{/*		<a href="mailto:info@epocagroup.it" target="_blank">MAIL US</a>*/}
						{/*	</li>*/}
						{/*	<li ref={el => itemsRef.current[10] = el}>*/}
						{/*		<a href="tel:+390255678900" target="_blank">TEL 02 55 67 89 00</a>*/}
						{/*	</li>*/}
						{/*</ul>*/}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Menu;
